const AreasSection = () => {
  const areas = [
    // Barrios de Castelldefels
    { name: 'Castelldefels Centre', type: 'main' },
    { name: 'La Pineda', type: 'main' },
    { name: 'Montemar', type: 'main' },
    { name: 'Can Roca', type: 'main' },
    { name: 'Bellamar', type: 'main' },
    { name: 'Vista Alegre', type: 'main' },
    { name: 'Granvia Mar', type: 'main' },
    { name: 'Baixador', type: 'main' },
    // Municipios cercanos
    { name: 'Gavà', type: 'nearby' },
    { name: 'Viladecans', type: 'nearby' },
    { name: 'El Prat de Llobregat', type: 'nearby' },
    { name: 'Sant Boi de Llobregat', type: 'nearby' },
    { name: 'Sitges', type: 'nearby' },
    { name: 'Cornellà de Llobregat', type: 'nearby' },
    { name: 'Esplugues de Llobregat', type: 'nearby' },
    { name: 'Sant Joan Despí', type: 'nearby' },
    { name: 'Sant Feliu de Llobregat', type: 'nearby' },
    { name: 'Molins de Rei', type: 'nearby' },
    { name: 'Sant Just Desvern', type: 'nearby' },
    { name: 'Barcelona Sur', type: 'nearby' },
  ];

  return (
    <section className="py-24 bg-silver-light/30">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-graphite mb-4">
            Zonas de <span className="text-primary">servicio</span>
          </h2>
          <p className="text-lg text-gray-medium max-w-3xl mx-auto">
            Ofrecemos nuestros servicios profesionales de vaciado de pisos, locales y limpieza extrema en Castelldefels y toda la comarca del Baix Llobregat Sud. Cobertura completa en más de 20 localidades
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-card p-8 md:p-12">
          {/* Barrios de Castelldefels */}
          <div className="mb-10">
            <h3 className="text-2xl font-bold text-graphite mb-6 flex items-center">
              <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center mr-3">
                <i className="ri-home-4-line text-white text-lg"></i>
              </div>
              Castelldefels - Todos los barrios
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {areas.filter(area => area.type === 'main').map((area, index) => (
                <div
                  key={index}
                  className="flex items-center space-x-3 p-4 bg-primary/5 rounded-xl hover:bg-primary/10 hover:shadow-md transition-all cursor-pointer border border-primary/20"
                >
                  <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-white text-lg"></i>
                  </div>
                  <span className="font-semibold text-graphite text-sm">{area.name}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Municipios cercanos */}
          <div>
            <h3 className="text-2xl font-bold text-graphite mb-6 flex items-center">
              <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center mr-3">
                <i className="ri-map-2-line text-white text-lg"></i>
              </div>
              Municipios del Baix Llobregat y alrededores
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {areas.filter(area => area.type === 'nearby').map((area, index) => (
                <div
                  key={index}
                  className="flex items-center space-x-3 p-4 bg-silver-light/50 rounded-xl hover:bg-primary/10 hover:shadow-md transition-all cursor-pointer"
                >
                  <div className="w-10 h-10 bg-graphite rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-2-line text-white text-lg"></i>
                  </div>
                  <span className="font-semibold text-graphite text-sm">{area.name}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Información adicional */}
          <div className="mt-10 bg-primary/5 rounded-2xl p-6 border border-primary/20">
            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-information-line text-white text-xl"></i>
              </div>
              <div className="flex-1">
                <h4 className="text-lg font-bold text-graphite mb-2">
                  Servicio en toda la comarca
                </h4>
                <p className="text-gray-medium mb-4">
                  Nuestro equipo profesional se desplaza a cualquier punto de Castelldefels y toda la comarca del Baix Llobregat Sud. También atendemos localidades cercanas de Barcelona zona sur.
                </p>
                <p className="text-gray-medium font-semibold">
                  ¿No encuentras tu zona? Contáctanos y te informaremos sobre la disponibilidad de nuestros servicios
                </p>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="mt-8 text-center">
            <a
              href="tel:+34602365996"
              className="inline-flex items-center px-8 py-4 bg-primary text-white rounded-lg font-semibold hover:bg-primary/90 hover:shadow-lg transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2 text-xl"></i>
              Consultar Disponibilidad - 602 36 59 96
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AreasSection;
